/* import __COLOCATED_TEMPLATE__ from './discrete-percentage-stepper.hbs'; */
var _dec, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { action, computed } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { formatBps } from '@capital/intl/utils';
const MAX_BPS = 100_00;
const MIN_BPS = 0;
const DEFAULT_BPS = 0;
let DiscretePercentageStepper = (_dec = computed('percentageValue'), (_class = class DiscretePercentageStepper extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _defineProperty(this, "maxPercentage", this.bpsToPercentage(typeof this.args.maxBps !== 'undefined' ? this.args.maxBps : MAX_BPS));
    _defineProperty(this, "minPercentage", this.bpsToPercentage(typeof this.args.minBps !== 'undefined' ? this.args.minBps : MIN_BPS));
    _initializerDefineProperty(this, "percentageValue", _descriptor2, this);
  }
  onChange(event) {
    const bps = event.detail.value * 100;
    this.percentageValue = this.bpsToPercentage(bps);
    this.args.onUpdate(bps);
  }

  // NOTE: market-stepper uses a <input type="number"/> so the % sign can't be part of the input
  // without being able to change the width of market-stepper's <input> based on different numbers' length,
  // we have to roughly calculate where the % sign needs to be
  // so that the % sign and the number (NOT the <input> element) stays close as if they are in the same <input>
  get percentSignPosition() {
    let position = 40;
    if (this.percentageValue < 10) {
      if (Math.floor(this.percentageValue) === this.percentageValue) {
        // 1. [0,10) integer
        position = 50;
      } else {
        // 2. [0,10) non-integer
        position = 44;
      }
    } else if (this.percentageValue < 100) {
      if (Math.floor(this.percentageValue) === this.percentageValue) {
        // 3. [10,100) integer
        position = 46;
      } else {
        // 4. [10,100) non-integer
        position = 40;
      }
    } else {
      position = 41;
    }
    return `right: ${position}px;`;
  }
  bpsToPercentage(value) {
    return Number.parseFloat(formatBps(value, this.intl).replace(/%/g, ''));
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "percentageValue", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.bpsToPercentage(typeof this.args.bps !== 'undefined' ? this.args.bps : DEFAULT_BPS);
  }
}), _applyDecoratedDescriptor(_class.prototype, "onChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "percentSignPosition", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "percentSignPosition"), _class.prototype)), _class));
export { DiscretePercentageStepper as default };